import React, { Component } from 'react';
import axios from 'axios';

const KULLANICI_OLUSTUR_API = 'https://randevuapi.uzmdrzelihaaksoy.com/kullanici-olustur';

class KullaniciEkle extends Component {

  constructor(props) {
    super(props);

    this.auth = localStorage.getItem('auth');

    this.state = {
      name: '',
      password: '',
      password2: '',
      isAdmin: false,
      submitting: false,
      formError: '',
      formSuccess: ''
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleBack = this.handleBack.bind(this);
  }

  handleBack() {
    this.props.history.goBack();
  }

  handleChange(event) {
    const { name, type, checked, value } = event.target;
    this.setState({ [name]: type === 'checkbox' ? checked : value });
  }

  handleSubmit(event) {
    event.preventDefault();

    const { name, password, password2, isAdmin } = this.state;

    if (!name.trim() || !password) {
      this.setState({ formError: 'Lütfen zorunlu alanları doldurunuz.', formSuccess: '' });
      return;
    }

    if (password.length < 6) {
      this.setState({ formError: 'Parola en az 6 karakter olmalıdır.', formSuccess: '' });
      return;
    }

    if (password !== password2) {
      this.setState({ formError: 'Parolalar eşleşmiyor.', formSuccess: '' });
      return;
    }

    this.setState({ submitting: true, formError: '', formSuccess: '' });

    const roles = isAdmin ? ['authenticated', 'administrator'] : ['authenticated'];

    axios.post(KULLANICI_OLUSTUR_API, {
      name: name.trim(),
      password,
      roles
    }, { headers: { Authorization: 'Basic ' + this.auth } })
      .then(() => {
        this.setState({
          submitting: false,
          formSuccess: 'Kullanıcı başarıyla oluşturuldu.',
          name: '',
          password: '',
          password2: '',
          isAdmin: false
        });
      })
      .catch(error => {
        const message = error.response && error.response.data && error.response.data.message;
        this.setState({ submitting: false, formError: message || 'Kullanıcı oluşturulamadı. Lütfen tekrar deneyiniz.' });
      });
  }

  render() {
    const { name, password, password2, isAdmin, submitting, formError, formSuccess } = this.state;

    return (
      <div className="max-w-md mx-auto space-y-7">
        <header className="space-y-3">
          <h1 className="text-2xl font-heading font-bold tracking-tight text-slate-900">Kullanıcı Ekle</h1>
          <p className="text-sm text-slate-500">Sisteme yeni bir kullanıcı ekleyin.</p>
          <button
            type="button" onClick={this.handleBack}
            className="inline-flex items-center gap-1.5 text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors"
          >
            <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="m15 18-6-6 6-6"></path></svg>
            Geri
          </button>
        </header>

        <form onSubmit={this.handleSubmit} className="bg-white rounded-xl border border-slate-200 shadow-sm p-6 flex flex-col gap-3">
          <label className="text-sm font-medium text-slate-700">
            Kullanıcı Adı
            <input
              name="name" value={name} onChange={this.handleChange}
              required type="text" placeholder="Kullanıcı adı"
              className="mt-1 w-full px-3 py-2 text-sm border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-400/40 focus:border-sky-400 transition-all"
            />
          </label>

          <label className="text-sm font-medium text-slate-700">
            Parola
            <input
              name="password" value={password} onChange={this.handleChange}
              required type="password" placeholder="Parola"
              className="mt-1 w-full px-3 py-2 text-sm border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-400/40 focus:border-sky-400 transition-all"
            />
          </label>

          <label className="text-sm font-medium text-slate-700">
            Parola (Tekrar)
            <input
              name="password2" value={password2} onChange={this.handleChange}
              required type="password" placeholder="Parola (tekrar)"
              className="mt-1 w-full px-3 py-2 text-sm border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-400/40 focus:border-sky-400 transition-all"
            />
          </label>

          <label className="flex items-center gap-2 text-sm font-medium text-slate-700 mt-1">
            <input
              name="isAdmin" checked={isAdmin} onChange={this.handleChange}
              type="checkbox"
              className="h-4 w-4 rounded border-slate-300 text-sky-600 focus:ring-sky-400/40"
            />
            Yönetici (administrator) yetkisi ver
          </label>

          <button
            type="submit"
            disabled={submitting}
            className="mt-2 h-10 px-4 rounded-md bg-sky-600 hover:bg-sky-700 text-white text-sm font-medium shadow-sm transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {submitting ? 'Kaydediliyor...' : 'Kullanıcı Ekle'}
          </button>

          {formSuccess && <p className="text-center text-sm text-emerald-600">{formSuccess}</p>}
          {formError && <p className="text-center text-sm text-red-600">{formError}</p>}
        </form>
      </div>
    );
  }
}

export default KullaniciEkle
